// extracted by mini-css-extract-plugin
export default {"input":"a-entity-search-input-module__input","autocomplete":"a-entity-search-input-module__autocomplete","icon":"a-entity-search-input-module__icon"};